import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from "react";

type CheckoutBookingCounselingContextType = {
  bookingData: any;
  onChangeBookingData: (value: any) => void;
};

const CheckoutBookingCounselingContext = createContext<
  CheckoutBookingCounselingContextType | undefined
>(undefined);

export const CheckoutBookingCounselingProvider = (props: PropsWithChildren) => {
  const [bookingData, setBookingData] = useState<any>(null);

  const onChangeBookingData = useCallback((value: any) => {
    setBookingData(value);
  }, []);

  return (
    <CheckoutBookingCounselingContext.Provider
      value={{
        bookingData,
        onChangeBookingData,
      }}
    >
      {props.children}
    </CheckoutBookingCounselingContext.Provider>
  );
};

export const useCheckoutBookingCounseling = () => {
  const ctx = useContext(CheckoutBookingCounselingContext);
  if (!ctx)
    throw new Error(
      "useBookingCounseling must be used within a CheckoutBookingCounselingProvider"
    );
  return ctx;
};
